var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { rgba } from 'polished';
var colors = {
    surfaceError: '#fb695e',
    textError: '#fb695e',
    surfacePromo: '#FF7438',
    textPromo: '#FF7438',
    surfaceAttention: '#ffc000',
    textAttention: '#ffc000',
    surfaceBrand: '#60C3FA',
    textBrand: '#60C3FA',
    textOnBrand: '#fff',
    surfaceSuccess: '#12C78C',
    textSuccess: '#12C78C',
    surfaceLine: '#EDF8F5',
    textMain: '#00362B',
    textSecondary: '#4D7979',
    surfaceIcon: '#9ECEC4',
    surfaceBorder: '#CBE4DF',
    surfaceBackground: '#E6F8F3',
    surfaceBackgroundSecondary: '#FAFFFE',
    surfaceBackgroundAlternate: rgba('#DFF5F5', 0.5),
    surfaceDisabled: '#778F9C',
};
var defaultShadow = {
    S: "0px 1px 1px rgba(0, 56, 110, 0.08)",
    M: '0 5px 15px rgba(0, 68, 133, 0.05)',
    L: '0px 10px 30px rgba(0, 68, 133, 0.15)',
};
var backgrounds = {
    lightGrey: '#EFF4FA',
    checkbox: '#fafcff',
    input: '#fff',
    mobileButton: 'linear-gradient(to right, rgba(255, 255, 255, 0) 70%, rgba(0, 0, 0, 0.04) 100%)'
};
var borders = {
    button: colors.surfaceBorder,
    checkbox: '#cedef2',
    whiteBlueButton: '#E1EDFA',
};
var defaultHeader = {
    bgColor: colors.surfaceBackgroundSecondary,
    linkColor: colors.surfaceBorder,
    activeLinkColor: colors.surfaceBackgroundSecondary,
    menuButtonColor: colors.surfaceBackgroundSecondary,
    activeMenuButtonColor: colors.surfaceBackgroundSecondary,
    desktopMenuBg: colors.surfaceBackgroundSecondary,
    boxShadow: defaultShadow.S,
};
var defaultPopup = {
    closeColor: '#AEB9C7',
    borderColor: '#DBE7F2',
    backgroundColor: '#fff',
};
var whiteHeader = __assign(__assign({}, defaultHeader), { bgColor: colors.surfaceBackgroundSecondary, linkColor: colors.textSecondary, activeLinkColor: colors.textMain, menuButtonColor: colors.surfaceBrand, activeMenuButtonColor: colors.surfaceBrand, desktopMenuBg: colors.surfaceBackgroundSecondary });
export var lightBlueTheme = {
    colors: colors,
    backgrounds: backgrounds,
    borders: borders,
    loginBackground: '#fff',
    popup: defaultPopup,
    shadow: defaultShadow,
    header: whiteHeader,
    globalBackground: colors.surfaceBackground,
    mixins: {
        maxContentWidth: '1224px',
    },
};
